// Classifies crew assignments by their relationship to a stage. Shared by
// the schedule creator (CrewSchedule) and the read-only producer view
// (ReadOnlyScheduleTimeline) so both decide "does this block belong in the
// stage row or in the per-crew Custom row?" identically.
//
// Background: a "custom" assignment is crew filming something that isn't a
// DJ set. When such an assignment is pinned to a real stage (e.g. filming
// the overview / audience of a stage that has no lineup), it should live in
// that stage's row — not the per-crew Custom row — so the stage stays the
// single place to see everything planned against it.

export type StageBoundAssignment = {
  assignment_type: "artist" | "custom";
  stage_id?: string | null;
};

// True for a custom assignment pinned to a stage that exists on the day.
// `dayStageIds` is the set of briefing_stages ids for the selected day.
// These render inside the stage row, so callers exclude them from the
// per-crew Custom row.
export function isStageBoundCustom(
  a: StageBoundAssignment,
  dayStageIds: ReadonlySet<string>,
): boolean {
  return a.assignment_type === "custom" && !!a.stage_id && dayStageIds.has(a.stage_id);
}

// True for a custom assignment that belongs to one specific stage row.
export function isCustomForStage(
  a: StageBoundAssignment,
  stageId: string | null | undefined,
): boolean {
  return a.assignment_type === "custom" && !!stageId && a.stage_id === stageId;
}
